import Paper from '@material-ui/core/Paper';
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { fetchJSON } from 'helpers/axios';
import {
  NotificationContainer,
  NotificationManager,
} from 'react-notifications';
import { color } from '@amcharts/amcharts4/core';
import { set } from 'nprogress';
import LoadingOverlay from 'react-loading-overlay';
import { makeStyles } from '@material-ui/core/styles';
import 'bootstrap/dist/css/bootstrap.min.css';
import bacohtlogo from 'assets/images/dashboard/bacohtlogo.png';
import Signature from './img/signature.png';
// import moment from "moment";
import { Box } from '@material-ui/core';

const useStyles = makeStyles({
  watermarkContainer: {
    position: 'relative',
    overflow: 'visible',
    minHeight: '100%',
  },
  watermarkWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    zIndex: 1,
  },
  watermarkImage: {
    width: '400px', // Adjust size as needed
    height: '120vh', // Adjust size as needed
    opacity: 0.1, // Adjust opacity as needed
    transform: 'rotate(-45deg)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'fixed', // This ensures it stays centered while scrolling
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    padding: '24px',
    backgroundColor: 'transparent',
  },
});

const Letter = ({ authUser, settings }) => {
  const classes = useStyles();
  const [letterAdm, setLetterAdm] = useState(null);
  const [letterAdmFeeRows, setLetterAdmFeeRows] = useState(null);
  const [loader, setLoader] = useState(false);
  const [watermarks, setWatermarks] = React.useState([]);
  const containerRef = useRef(null);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;
      const height = containerRef.current.offsetHeight;
      const numX = Math.ceil(width / 300); // 300 = image width + margin
      const numY = Math.ceil(height / 300); // 300 = image height + margin
      const marks = [];
      for (let y = 0; y < numY; y++) {
        for (let x = 0; x < numX; x++) {
          marks.push({ id: `${x}-${y}` });
        }
      }
      setWatermarks(marks);
    }
  }, []);

  useEffect(async () => {
    // debugger;
    try {
      const { token, ApplicantID } = authUser;
      setLoader(true);
      const response = await fetchJSON(
        `api/ProvisionalAdmissionLetter00?applicantId=${ApplicantID}`,
        null,
        'GET',
        token
      );

      setLoader(false);
      setLetterAdmFeeRows(response.Data.feeRows)
      setLetterAdm(response.Data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  if (!isLargeScreen) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f8d7da",
          color: "#721c24",
          fontFamily: "Roboto, sans-serif",
          fontSize: "1rem",
        }}
      >
        Sorry, this page is not accessible on screens smaller than 768px. Please
        use a larger device to view this content.
      </div>
    );
  }

  return (
    <>
      <LoadingOverlay active={loader} spinner text='Fetching Data'>
        <Paper elevation={2}>
          <Box className={classes.watermarkContainer} ref={containerRef}>
            <div
              style={{
                margin: 0,
                paddingTop: '80px',
                fontFamily: 'Arial, sans-serif',
                // height: '100vh',
              }}
            >
              <div
                id='content'
                className='container'
                style={{
                  width: '25cm',
                  minHeight: '37cm',
                  margin: '0 auto',
                  position: 'relative',
                  backgroundColor: 'white',
                  padding: '20px',
                  boxSizing: 'border-box',
                }}
              >
                {/* containers  */}
                <div
                  style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    right: '20px',
                    bottom: '20px',
                    pointerEvents: 'none',
                  }}
                >
                  {/* page content goes here */}
                  <p>The details of all fees payable are as follows:</p>

                  <div>
                    <table style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      marginBottom: '20px'
                    }}>
                      <tbody>
                        {letterAdmFeeRows && (
                          <div dangerouslySetInnerHTML={{ 
                            __html: `<table style="width: 100%; border-collapse: collapse;">
                              <tbody>
                                ${letterAdmFeeRows.replace(/<td/g, '<td style="border: 1px solid black; padding: 8px;"')
                                                  .replace(/<th/g, '<th style="border: 1px solid black; padding: 8px; font-weight: bold;"')}
                              </tbody>
                            </table>`
                          }} />
                        )}
                      </tbody>
                    </table>
                  </div>
                  <p
                      style={{ fontSize: '18px', fontWeight: 'bold' }}
                      className='mt-4'
                    >
                      PLEASE NOTE:
                    </p>
                    <p style={{ fontSize: '14px' }}>
                      All fees should be duly paid online through{' '}
                      <strong>COLLEGE PORTAL</strong>.
                    </p>

                  {/* Bottom border line */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '75px',
                      left: 0,
                      right: 0,
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      style={{ flex: 1, borderBottom: '1px solid #cc9933' }}
                    ></div>
                    <div style={{ width: '300px' }}></div>
                    <div
                      style={{ flex: 1, borderBottom: '1px solid #cc9933' }}
                    ></div>
                  </div>

                  {/* <!-- Watermark Placeholder --> */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      opacity: '0.1',
                      pointerEvents: 'none',
                    }}
                  >
                    <img
                      style={{
                        width: '500px',
                        height: '500px',
                        borderRadius: '50%',
                        // backgroundImage: `url(${bacohtlogo})`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      src={bacohtlogo}
                    />

                    {/* </image> */}
                  </div>

                  {/* <!-- Bottom Logo Placeholder --> */}
                  <div
                    style={{
                      width: '80px',
                      // height: '80px',
                      // borderRadius: '50%',
                      // backgroundColor: '#006838',
                      // color: '#006838',
                      position: 'absolute',
                      bottom: '24px',
                      left: '45%',
                      transform: 'translateX(-50%)',
                      transform: 'translateY(-50%)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <p
                      style={{
                        fontFamily: 'Roboto',
                        color: '#0e2b1e',
                        fontSize: '16px',
                        textWrap: 'nowrap',
                        fontWeight: '700',
                      }}
                    >
                      INSTITUTION CONTACT DETAILS
                    </p>
                  </div>

                  {/* Footer */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: '20px',
                      right: '20px',
                      textAlign: 'center',
                      fontSize: '14px',
                      color: '#666',
                    }}
                  >
                    <span
                      style={{
                        margin: '5px 0',
                        fontWeight: 'normal',
                        color: '#000',
                      }}
                    >
                      <span style={{ fontWeight: '800', color: '#000' }}>
                        A:{' '}
                      </span>
                      Egbejila Road Behind Solid Worth Hotel, Asa Dam Area,
                      Ilorin, Kwara State, Nigeria
                    </span>
                    <span
                      style={{
                        margin: '5px 0',
                        fontWeight: 'normal',
                        color: '#000',
                      }}
                    >
                      <span style={{ fontWeight: '800', color: '#000' }}>
                        {' '}
                        T:{' '}
                      </span>
                      +234 802 954 1012, +234 810 396 9334
                    </span>
                    <br />
                    <span
                      style={{
                        margin: '5px 0',
                        fontWeight: 'normal',
                        color: '#000',
                      }}
                    >
                      <span style={{ fontWeight: '800', color: '#000' }}>
                        E:
                      </span>{' '}
                      babalolaacademy@gmail.com, www.babalolacollege.edu.ng
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Paper>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;

  const settings = auth;

  return { authUser, settings };
};

export default connect(mapStateToProps, {})(Letter);
